<script setup lang="ts">
  import useCpBem from '~/composables/useCpBem';
  import CpText from '~/components/cp/CpText/CpText.vue';
  // return module pictures
  import productPackage from '~/assets/img/product_package.svg';
  import barCode from '~/assets/img/bar_code.svg';
  import parcelGuide from '~/assets/img/parcel_guide.svg';
  import laptopFront from '~/assets/img/laptop_front.svg';
  import laptopAbove from '~/assets/img/laptop_above.svg';
  import laptopSide from '~/assets/img/laptop_side.svg';
  import packageBox from '~/assets/img/package_box.svg';
  import packageBoxOpen from '~/assets/img/package_box_open.svg';
  import brokenScreen from '~/assets/img/broken_screen.svg';
  import brokenLaptop from '~/assets/img/broken_laptop.svg';
  import laptopSupport from '~/assets/img/laptop_support.svg';
  import screenSupport from '~/assets/img/screen_support.svg';

  defineProps<{
    returnModule?: boolean,
    picture: string,
    number?: string
  }>();
  const {b, e} = useCpBem('cp-image');

  const svgImg = {
    productPackage,
    barCode,
    parcelGuide,
    laptopFront,
    laptopAbove,
    laptopSide,
    packageBox,
    packageBoxOpen,
    brokenScreen,
    brokenLaptop,
    laptopSupport,
    screenSupport,
  };
</script>

<template>
    <div :class="b">
        <div v-if="returnModule">
            <div :class="e('number')">
                <CpText variant="caption-bold" type="white">
                    {{ number }}
                </CpText>
            </div>
            <div :class="e('return-module')">
                <img :src="svgImg[picture]" :class="e('return-image')">
            </div>
        </div>
        <img v-else :class="e('img')" :src="picture">
    </div>
</template>

<style scoped lang="scss">
  .cp-image {
    z-index: 0;
    position: relative;
    &__img {
      border-radius: $cp-border-radius;
      height: 158px;
      object-fit: cover;
      width: 100%;
    }
    &__return-image {
      max-width: 86px;
      max-height: 86px;
    }
    &__return-module {
      width: 88px;
      height: 88px;
      border: 1px solid var(--color-neutral-light);
      border-radius: $cp-border-radius;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__number {
      background-color: var(--color-primary);
      border-radius: $cp-border-radius-rounded;
      width: 16px;
      height: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
      position: absolute;
      margin: $cp-gutter-small;
    }
  }
</style>
